<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Editar medio</h5>
    <div mat-dialog-content>
      <!--begin::Form-->
      <form class="form" [formGroup]="editMedioForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
        <div class="form-group">
          <br-alert *ngIf="showAlert"></br-alert>
          <p><strong>ID: </strong>{{medioData.id}}</p>
          <p><strong>Fecha de creación: </strong>{{medioData.createdAt | date: 'MMMM d, y'}}</p>
          <mat-form-field class="w-100">
            <mat-label>Medio</mat-label>
            <input matInput type="text"
              formControlName="medio" autocomplete="off" />
            <mat-error *ngIf="isControlHasError('medio', 'required')">
              <strong>Campo requerido</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </form>
      <!--end::Form-->
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick(false)">Cerrar</button>
      <button mat-button cdkFocusInitial (click)="submit(editMedioForm)">Guardar</button>
    </div>
  </div>